import { render, staticRenderFns } from "./StockDaysFilter.vue?vue&type=template&id=1246b2cb&"
import script from "./StockDaysFilter.vue?vue&type=script&lang=js&"
export * from "./StockDaysFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports